import { NavLink } from 'react-router-dom';
import { can, type Me } from '../auth/me';
import { BLOCKS_RESOURCE, KITS_RESOURCE, TEMPLATES_RESOURCE } from './types';

/**
 * "Szablony wydarzeń" | "Bloki sprzętu" | "Zestawy": the lists of the "Szablony" section (owner 20.10 23:37: kits live
 * here too), as far as the role may see them. Segments like the tabs of "Finanse" (rule 7: one look of tabs).
 */
export function SectionNav({ me }: { me: Me }) {
  const links = [
    ...(can(me, TEMPLATES_RESOURCE, 'view') ? [{ to: '/szablony', label: 'Szablony wydarzeń' }] : []),
    ...(can(me, BLOCKS_RESOURCE, 'view') ? [{ to: '/szablony/bloki', label: 'Bloki sprzętu' }] : []),
    ...(can(me, KITS_RESOURCE, 'view') ? [{ to: '/szablony/zestawy', label: 'Zestawy' }] : []),
  ];
  return (
    <nav className="section-tabs" aria-label="Szablony">
      <div className="segment">
        {links.map((l) => (
          <NavLink key={l.to} to={l.to} end>
            {l.label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
